import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  Typography,
} from '@mui/material'
import { type FC, useCallback, useState } from 'react'
import { useCopyLabelAreas } from 'src/features/labelMaster/api/useCopyLabelAreas'

type Props = {
  sourceLabelId: string
  hasAreas: boolean
  id: string
}

export const PasteAreaModal: FC<Props> = ({ sourceLabelId, id, hasAreas }) => {
  const copyMutation = useCopyLabelAreas()
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)

  const handlePasteAreas = useCallback(() => {
    if (!sourceLabelId) return

    copyMutation.mutate({
      sourceLabelId,
      targetLabelId: id,
    })
    close()
  }, [id, sourceLabelId, copyMutation])

  const onClickPasteAreas = useCallback(() => {
    // すでに検査箇所がある場合は上書きの許可を得るため、Dialogを表示
    if (hasAreas) {
      setOpen(true)
      return
    }
    // 検査箇所がない場合はペーストを実行
    handlePasteAreas()
  }, [handlePasteAreas, hasAreas])

  return (
    <>
      <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
        <DialogContent sx={{ px: 3, py: 2 }}>
          <Typography
            fontWeight="bold"
            variant="h6"
            color="text.primary"
            fontSize={20}
          >
            既に登録されている検査箇所と位置補正基準は全て上書きされます。続けてもよろしいですか？
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="text" size="medium" onClick={close}>
            キャンセル
          </Button>
          <Button
            variant="text"
            color="error"
            size="medium"
            onClick={handlePasteAreas}
          >
            続ける
          </Button>
        </DialogActions>
      </Dialog>
      <MenuItem onClick={onClickPasteAreas}>
        <Typography
          variant="body2"
          color="text.primary"
          fontWeight="500"
          textAlign="left"
        >
          検査箇所のペースト
        </Typography>
      </MenuItem>
    </>
  )
}
